<template>
  <the-dialog v-model="dialog"/>

  <div class="frame-container-custom">
    <div class="frame-body">
      <div class="container-fluid header-custom shadow-custom">
        <div class="row justify-content-center align-items-center header-row-custom mx-1 mx-sm-5 py-2 pb-sm-3">
          <div class="col text-start p-0" :class="{ 'logo-container-with-text': textInsteadOfLogo }">
            <component :is="clickableLogoOrText ? 'a' : 'div'" :href="clickableLogoOrText ? this.Config.Producer.Website : null" :target="clickableLogoOrText ? '_blank' : null" :class="{ 'logo-link-custom': clickableLogoOrText }">
              <img v-if="logoImage" :src="logoImage" class="logo-custom">
              <div v-if="textInsteadOfLogo" class="logo-text-custom rounded-1 border text-center fw-bold fs-3"><img src="@/assets/shield.svg" class="text-shield-custom"><span class="agency-name-custom">{{textInsteadOfLogo}}
                <br>
                <div class="fs-6 licensed-custom mt-1">{{$t('app.licenced-agent')}}</div>
              </span>
              </div>
            </component>
          </div>
          <div class="col align-self-end text-end p-0 pb-3 pb-sm-1">
            <button class="btn btn-outline-info btn-sm language-button-custom" type="button" @click="toggleLanguage"> <font-awesome-icon icon="globe-americas" /> {{$t('app.toggle-language')}}</button>
            <button class="btn btn-outline-info btn-sm language-button-custom" type="button" @click="showHelp"> <font-awesome-icon icon="question-circle" style="color: #01b67a" /> </button>
            <button class="btn btn-outline-info btn-sm language-button-custom" type="button" @click="startOver"> <font-awesome-icon icon="rotate-left" /> {{$t('app.start-over')}}</button>
          </div>
        </div>
      </div>

      <div class="container-fluid photo-container-custom">
        <div class="row justify-content-center">
          <div class="col">
            <div v-if="showBackArrow" class="back-arrow-custom">
              <font-awesome-icon icon="chevron-left" size="3x" @click="back" />
            </div>
          </div>
          <div class="col text-center">
            <img v-if="operatorImage" :src="operatorImage" @click="showHelp" class="photo-custom-block animate__animated animate__zoomIn shadow-custom p-1" />
          </div>
          <div class="col">
          </div>
        </div>
      </div>

      <router-view v-if="status == 'ok'" />

      <div v-if="['requesting', 'error'].includes(status)" class="container-fluid" style="padding-top: 40px">
        <div class="row justify-content-center">
          <div class="col text-center">
            <button :disabled="status == 'requesting'" class="btn btn-primary cool-primary-gradient" @click="refreshAgency">
              {{status == 'error' ? $t('app.retry') : $t('app.requesting')}}
              <spinner :processing="status == 'requesting'" color='#3c3' size="16px" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <app-footer/>

    <rtf-dialog v-if="screenHelpAvailable"
      v-model="screenHelpDialog"
      :title="screenHelpDialogTitle"
      :body="screenHelpDialogBody"
      :close="screenHelpDialogClose"
      :contact="true"
      :argument-object="{ phone: Config.Producer.Phone, agency: Config.Producer.Agency, website: Config.Producer.Website }" />

    <alert-dialog v-model="unsupportedBrowserDialog" :message="errorMessage" />
  </div>
</template>

<style scoped lang="scss">
  .licensed-custom {
    color: #aaa;
  }

  .text-shield-custom {
    display: block;
    flex: 0 0 auto;
    width: 1.5em;
    height: 1.5em;
    margin-right: 0;
  }

  .header-custom {
    border-bottom: 1px solid #ddf;
  }

  .shadow-custom {
    box-shadow: 0 4px 6px -1px rgba(0,0,0,.1),0 2px 4px -1px rgba(0,0,0,.06);
  }

  .header-row-custom {
    min-height: 45px;
  }

  .photo-container-custom {
    max-height: 50px;
  }

  .frame-container-custom {
    padding-bottom: 60px;
    min-height: 100%;
    position: relative;
  }

  .logo-custom {
    position: relative;
    object-fit: contain;
    object-position: left;
    left: 0px;
    margin-left: 4px;
    margin-top: 4px;
    margin-bottom: 2px;
    width: auto;
    width: clamp(120px, 25vw, 300px);
    height: auto;
    max-height: 120px;
  }

  .logo-container-with-text {
    margin-right: 80px;
  }

  .logo-text-custom {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.35em;
    padding: 0.2em 0.65em;
    line-height: 1.1;
    max-width: 100%;
    margin-right: 40px;
    border-color: #a0a0a0 !important;
    color: #000;
  }

  .agency-name-custom {
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
    text-align: center;
  }

  .logo-link-custom,
  .logo-link-custom:hover,
  .logo-link-custom:focus,
  .logo-link-custom:active,
  .logo-link-custom:visited {
    text-decoration: none;
    color: var(--bs-link-color, #0d6efd);
  }

  .logo-link-custom:hover,
  .logo-link-custom:focus {
    color: var(--bs-link-hover-color, #0a58ca);
  }

 .language-button-custom {
    border-color: #a0a0a0;
    float: right;
    margin-right: 4px;
    margin-top: 3px;
    margin-bottom: 2px;
  }

  .language-button-custom:hover {
    color: white;
  }

  @media (max-width: 330px) {
    .language-button-custom {
      font-size: 3.5vw;
    }
  }

  .back-arrow-custom {
    position: relative;
    top: 3px;
    left: -6px;
    color: #ccc;
    z-index: 100;
  }

  .back-arrow-custom:hover {
    color: #5a4;
  }

  .photo-custom-block {
    border-radius: 35%;
    border: 1px solid #ddf;
    padding: 0px;
    width: 80px;
    height: 80px;
    position: relative;
    top: -40px;
    background: white;
    cursor: pointer;
  }

  .step {
    font-size: 11px;
    text-align: center;
    color: #666;
    cursor: default;
    margin: 0 2px;
    padding: 10px 10px 10px 30px;
    min-width: 50px;
    float: left;
    position: relative;
    background-color: #08b9eb;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition: background-color 1s ease;
    max-height: 34px;
  }

  .step:after,
  .step:before {
    content: " ";
    position: absolute;
    top: 0;
    right: -17px;
    width: 0;
    height: 0;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    border-left: 17px solid #08b9eb;
    z-index: 2;
    transition: border-color 1s ease;
  }

  .step:before {
    right: auto;
    left: 0;
    border-left: 17px solid white;
    z-index: 0;
  }

  .step:first-child:before {
    border: none;
  }

  .step:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .step span {
    position: relative;
  }

  .step span:before {
    opacity: 0;
    content: "✔";
    position: absolute;
    top: -2px;
    left: -20px;
  }

  .step.done span:before {
    opacity: 1;
    -webkit-transition: opacity 0.3s ease 0.5s;
    -moz-transition: opacity 0.3s ease 0.5s;
    -ms-transition: opacity 0.3s ease 0.5s;
    transition: opacity 0.3s ease 0.5s;
  }

  .step.current {
    color: #fff;
    background-color: #23468c;
  }

  .step.current:after {
    border-left: 17px solid #23468c;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>

<script>
  import lib from '@/lib'
  import config from '@/Config.js'
  import { mapFields } from 'vuex-map-fields'
  import RtfDialog from '@/components/RtfDialog'
  import Spinner from '@/components/Spinner'
  import AppFooter from '@/components/AppFooter'
  import AlertDialog from '@/components/AlertDialog'
  import TheDialog from '@/components/Dialog'

  export default {
    components: {
      RtfDialog,
      Spinner,
      AppFooter,
      AlertDialog,
      TheDialog,
    },

    props: [
      'DataLayer'
    ],

    data: function() {
      return {
        screenHelpDialog: false,
        status: '',

        operatorImage: '',

        logoImage: '',
        textInsteadOfLogo: '',

        clickableLogoOrText: false,

        unsupportedBrowserDialog: false,
        errorMessage: '',
      }
    },

    created: function() {
      // copy the whole config for other screens to access its data without reloading it
      this.Config = config

      for (let event of ['click', 'keyup']) {
        document.addEventListener(event, () => {
          this.InactiveSeconds = 0
        })
      }

      setInterval(() => {
        if ( this.InactiveSeconds == this.Config.Timeout - 1 ) {
          this.InactiveSeconds = 0
          this.PaymentCreditCard = ''
          this.PaymentCVC = ''
        } else {
          this.InactiveSeconds = this.InactiveSeconds+1
        }
      }, this.Config.Defaults.IdleTimeout)

      // config loading
      this.Program = this.Config.Defaults.Program
      this.Vehicles = this.Config.Vehicles
      this.States = this.Config.States
      this.DaysOfCoverage = this.Config.DaysOfCoverage
      this.VehicleValues = this.Config.VehicleValues
      this.LiabilityLimits = this.Config.LiabilityLimits
      let vehicleYears = []
      for ( let year = new Date().getFullYear() + 1; year >= new Date().getFullYear() - 25; year-- ) {
        vehicleYears.push({ Value: year, Display: year })
      }
      this.VehicleYears = vehicleYears
      this.LimitTable = this.Config.LimitTable
      this.SelectedDaysOfCoverage = this.Config.Defaults.DaysOfCoverage
      this.SelectedVehicleValue = this.Config.Defaults.VehicleValue
      this.SelectedLiabilityLimit = this.Config.Defaults.LiabilityLimit
      this.SelectedDriverInfoCountry = this.Config.Defaults.DriverInfoCountry
      this.SelectedDriverInfoState = this.Config.Defaults.DriverInfoState
      this.TermsAndConditionsAccepted = this.Config.Defaults.TermsAndConditionsAccepted
      this.SelectedVehicleCountry = this.Config.Defaults.VehicleCountry
      this.LienholderSelection = this.Config.Defaults.LienholderSelection
      this.LienholderCountry = this.Config.Defaults.LienholderCountry
      this.RegisteredInMexico = this.Config.Defaults.RegisteredInMexico
      this.RentalVehicle = this.Config.Defaults.RentalVehicle
      this.FullCoverageInUSA = this.Config.Defaults.FullCoverageInUSA

      let params = new URLSearchParams(window.location.search.substring(1))
      //let params = this.captureAndCleanParams()

      if ( !lib.isProd() && params.get('Defaults') != undefined ) {
        this.SelectedDaysOfCoverage = this.Config.Defaults.Development.DaysOfCoverage
        this.SelectedVehicleValue = this.Config.Defaults.Development.VehicleValue
        this.AllDriversInAgeRange = this.Config.Defaults.Development.AllDriversInAgeRange
        this.VehicleVin = this.Config.Defaults.Development.VehicleVin
        this.SelectedVehicleState = this.Config.Defaults.Development.VehicleState
        this.LicensePlate = this.Config.Defaults.Development.LicensePlate
        this.ApplicantFirstName = this.Config.Defaults.Development.ApplicantFirstName
        this.ApplicantLastName = this.Config.Defaults.Development.ApplicantLastName
        this.ApplicantDateOfBirth = this.Config.Defaults.Development.ApplicantDateOfBirth
        this.ApplicantAddress = this.Config.Defaults.Development.ApplicantAddress
        this.ApplicantUnit = this.Config.Defaults.Development.ApplicantUnit
        this.TermsAndConditionsAccepted = this.Config.Defaults.Development.TermsAndConditionsAccepted
        this.DriversLicense = this.Config.Defaults.Development.DriversLicense
        this.SelectedDriverInfoCountry = this.Config.Defaults.Development.DriverInfoCountry
        this.SelectedDriverInfoState = this.Config.Defaults.Development.DriverInfoState
        this.ApplicantEmail = this.Config.Defaults.Development.ApplicantEmail
        this.ApplicantPhone = this.Config.Defaults.Development.ApplicantPhone
        this.PaymentCreditCard = this.Config.Defaults.Development.PaymentCreditCard
        this.PaymentCVC = this.Config.Defaults.Development.PaymentCVC
        this.PaymentMM = this.Config.Defaults.Development.PaymentMM
        this.PaymentYY = String(new Date().getFullYear() + 2).slice(-2)
        this.PaymentZip = this.Config.Defaults.Development.PaymentZip
        this.LienholderName = this.Config.Defaults.Development.LienholderName
        this.LienholderCountry = this.Config.Defaults.Development.LienholderCountry
        this.LienholderAddress1 = this.Config.Defaults.Development.LienholderAddress1
        this.LienholderAddress2 = this.Config.Defaults.Development.LienholderAddress2
        this.LienholderCity = this.Config.Defaults.Development.LienholderCity
        this.LienholderState = this.Config.Defaults.Development.LienholderState
        this.LienholderPostalCode = this.Config.Defaults.Development.LienholderPostalCode

        this.CoverageAndPaymentStartDate = (new Date().getMonth()+1) + '/' + (new Date().getDate()) + '/' + (new Date().getFullYear())
      }

    },

    mounted: function() {
      // On app load, check the initial url as provided, if it has no producer code (initial url route) or, it has it with an attempt
      // of an additional route to jump to, then redirct to the default url
      let parts = window.location.pathname.split('/').filter( i => i )
      if ( parts.length == 0 || ( parts.length >= 2 && parts[1].toLowerCase() != 'stamp' && parts[1].toLowerCase() != 'es') ) {
        this.$router.push({ path: '/' + this.getSetProducer(this.defaultProducerCode) })
      }

      let _self = this
      this.$router.beforeEach((to, from, next) => {
        next(!_self.Processing)
      })
    },

    updated: function() {
      lib.ga({ 'event': 'optimize.LocaleChange', 'locale': this.$i18n.locale })

      if ( this.PaymentPolicyNumber != '' && !this.$route.path.endsWith('/confirmation') ) {
        this.$router.push({ name: 'confirmation' })
      } else if ( this.PaymentPolicyNumber == '' && this.$route.path.endsWith('/confirmation')) {
        this.$router.push({ name: 'quote1' })
      }

      lib.setupTooltips()
    },

    watch: {
      $route() {

        // allow /es and /stamp in the root path segment as special conditions, mimicking the Spanish and Stamp views
        if ( this.$route.params ) {
          if ( this.$route.params.producer.length > 4 ) {
            localStorage.setItem('Producer.Code', this.Config.Producer.Code = this.$route.params.producer)
            this.refreshAgency()
          } else if ( this.$route.params.producer && this.$route.params.producer.length != 7 ) {
            window.location.href = 'producer-not-found.html'
          }
        }

        lib.ga({ 'event': 'optimize.activate', 'locale': this.$i18n.locale })
      }
    },

    methods: {
      getSetProducer(_default) {
        let producer = (localStorage.getItem('Producer.Code') || '').trim() || _default
        localStorage.setItem('Producer.Code', producer)
        return producer
      },

      refreshAgency: async function() {

        if ( !this.Config.Producer.Agency ) {

          this.Config.Producer.Agency = ''
          this.Config.Producer.Phone = ''
          this.Config.Producer.Website = ''
          this.status = 'requesting'

          try {
            let response = await lib.agencyInfo(this.Config.Producer.Code)

            let parts = window.location.pathname.split('/').filter( i => i )
            if ( parts.length > 0 && this.isAvocadoDomain && parts[0] != this.Config.Producer.AvocadoCode.toLowerCase() ) {
              localStorage.setItem('Producer.Code', this.Config.Producer.AvocadoCode)
              await this.$router.replace('/' + this.Config.Producer.AvocadoCode + (window.location.search || ''))
              window.location.reload()
              return
            }

            // if the server returns a suggested code it's because a legacy code was used, so I must replace it
            if ( response.suggestedCode ) {
              localStorage.setItem('Producer.Code', response.suggestedCode)
              await this.$router.replace('/' + response.suggestedCode.trim() + (window.location.search || ''))
              window.location.reload()
              return
            }

            this.Config.Producer.Agency = response.agency
            this.Config.Producer.Phone = response.phone
            this.operatorImage = response.operator_image == 'false' ? '/img/photo.jpg' : response.operator_image

            this.logoImage = response.logo_image == 'false' ? '' : response.logo_image
            this.textInsteadOfLogo = this.logoImage ? '' : response.agency

            response.website = ('' + (response.website || '')).trim().toLowerCase()
            if ( response.website && !response.website.startsWith('http://') && !response.website.startsWith('https://') ) {
              response.website = 'https://' + response.website
            }
            this.clickableLogoOrText = response.website ? true : false
            this.Config.Producer.Website = response.website

            await lib.setGoogleTagManagerId(response.googleTagId)

            lib.ga({ 'event': 'optimize.CoverageAndLimitsReview', 'locale': this.$i18n.locale })

            this.status = 'ok'
            this.qbcountries = response.countries
            this.qbstates = response.states
            this.qbmunicipalities = response.municipalities
          } catch (ex) {
            console.log(ex)
            localStorage.removeItem('Producer.Code')
            window.location.href = 'producer-not-found.html'
            this.status = 'error'
          }
        }
      },

      back: function() {
        lib.previousRoute(this.$router, this.SelectedVehicleValue == 'Liability only', this.isStamp)
      },

      toggleLanguage: function() {
        this.$i18n.locale = this.$i18n.locale == 'en' ? 'es' : 'en'
      },

      showHelp: function() {
        if ( this.screenHelpAvailable && this.status == 'ok' ) {
          this.screenHelpDialog = true
        }
      },

      startOver: function() {
        this.dialog = { show: true, type: 'info', title: this.$t('app.startover-dialog-title'), body: this.$t('app.startover-dialog-body'), button: this.$t('app.startover-dialog-yes'), cancel: this.$t('app.startover-dialog-no'), onClose: (accepted) => {
          if ( accepted ) {
            window.location.reload()
          }
        } }
      },

      captureAndCleanParams: function() {
        // grab params
        let params = new URLSearchParams(window.location.search)
        let paramsString = params.toString()

        // store in session storage and scrub url
        if ( paramsString ) {
          sessionStorage.setItem('pending_utms', paramsString)

          this.$router.replace({ 
            path: this.$route.path, 
            query: {} 
          }).catch()
        }

        return params
      }
    },

    computed: {
      isAvocadoDomain: function() {
        let hostname = (new URL(window.location.href).hostname || '').trim().toLowerCase()
        return hostname.includes('avocadoinsurance.com')
      },

      defaultProducerCode: function() {
        return lib.isDev() ? this.Config.Defaults.Development.ProducerCode :
          (this.isAvocadoDomain ? this.Config.Producer.AvocadoCode : this.Config.Producer.Code)
      },

      isStamp: function() {
        return this.Program == this.Config.Programs.stamp
      },

      showBackArrow() {
        return this.$route.name != 'quote1' && this.$route.name != 'confirmation' && this.status != 'requesting'
      },

      screenHelpAvailable: function() {
        let routeName = this.$route && this.$route.name ? this.$route.name : ''
        if (!routeName) {
          return false
        }
        let path = routeName + '.screen-help.title'
        return this.$t(path) != path
      },

      screenHelpDialogTitle: function() {
        let routeName = this.$route && this.$route.name ? this.$route.name : ''
        return this.$t((routeName || 'quote1') + '.screen-help.title')
      },

      screenHelpDialogBody: function() {
        let routeName = this.$route && this.$route.name ? this.$route.name : ''
        return this.$t((routeName || 'quote1') + '.screen-help.body')
      },

      screenHelpDialogClose: function() {
        let routeName = this.$route && this.$route.name ? this.$route.name : ''
        return this.$t((routeName || 'quote1') + '.screen-help.close')
      },

      ...mapFields([
        'dialog',
        'PaymentMM',
        'PaymentYY',
        'PaymentZip',
        'LicensePlate',
        'ApplicantFirstName',
        'ApplicantLastName',
        'ApplicantDateOfBirth',
        'ApplicantAddress',
        'ApplicantUnit',
        'TermsAndConditionsAccepted',
        'DriversLicense',
        'ApplicantEmail',
        'ApplicantPhone',
        'CoverageAndPaymentStartDate',
        'SelectedVehicleState',
        'VehicleVin',
        'AllDriversInAgeRange',
        'FullCoverageInUSA',
        'RegisteredInMexico',
        'RentalVehicle',
        'DaysOfCoverage',
        'VehicleValues',
        'LiabilityLimits',
        'VehicleYears',
        'LimitTable',
        'SelectedDaysOfCoverage',
        'SelectedVehicleValue',
        'SelectedLiabilityLimit',
        'SelectedDriverInfoCountry',
        'SelectedDriverInfoState',
        'SelectedVehicleCountry',
        'States',
        'qbcountries',
        'qbstates',
        'qbmunicipalities',
        'Vehicles',
        'PaymentCreditCard',
        'PaymentCVC',
        'Config',
        'InactiveSeconds',
        'Program',
        'PaymentPolicyNumber',
        'LienholderSelection',
        'LienholderName',
        'LienholderCountry',
        'LienholderAddress1',
        'LienholderAddress2',
        'LienholderCity',
        'LienholderState',
        'LienholderPostalCode',
        'InsuranceCompany',
        'Processing',
      ]),

    },
  }
</script>
